import React from 'react';
import { ComponentProps, SIZE, WEIGHT, ELEMENT, VARIANT, COLOR } from './Text.types';
import StyledText from './Text.styled';

const Text: React.FC<ComponentProps> = ({
  size = SIZE.BODY_TEXT,
  variant = VARIANT.PRIMARY,
  weight = 'normal',
  as = ELEMENT.P,
  color,
  ...props
}) => {
  const weightMap = new Map([
    [WEIGHT.NORMAL.toString(), 400],
    [WEIGHT.BOLD.toString(), 600],
  ]);

  const sizeMap = new Map([
    [
      SIZE.BODY_TEXT.toString(),
      {
        fontSize: 4,
        lineHeight: 6,
      },
    ],
    [SIZE.SMALL_TEXT.toString(), { fontSize: 3, lineHeight: 5 }],
  ]);

  const variantMap = new Map([
    [VARIANT.PRIMARY.toString(), 'secondary'],
    [VARIANT.SECONDARY.toString(), 'primary'],
  ]);

  const colorMap = new Map([
    [COLOR.LIGHT.toString(), 'var(--color-smoke)'],
    [COLOR.WARNING.toString(), 'var(--color-honey)'],
  ]);

  const element = sizeMap.get(size);

  const colorProp = colorMap.get(color) || color;

  return (
    <StyledText
      {...props}
      as={as}
      fontSize={element.fontSize}
      lineHeight={element.lineHeight}
      fontFamily={variantMap.get(variant)}
      fontWeight={weightMap.get(weight)}
      color={colorProp}
    />
  );
};

export default Text;
